import { bus_monitoring } from "../../../models/response/bus/bus_monitoring";

export enum eBusMonitoringActionTypeIds {
	LOAD_START = "BUS_MONITORING_LOAD_START",
	LOAD_SUCCESS = "BUS_MONITORING_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_MONITORING_LOAD_ERROR",

	SHOW_DETAIL = "BUS_MONITORING_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_MONITORING_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_MONITORING_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_MONITORING_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_MONITORING_CLOSE_CONFIRM",

	DELETE_START = "BUS_MONITORING_DELETE_START",
	DELETE_SUCCESS = "BUS_MONITORING_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_MONITORING_DELETE_ERROR",

	SAVE_START = "BUS_MONITORING_SAVE_START",
	SAVE_SUCCESS = "BUS_MONITORING_SAVE_SUCCESS",
	SAVE_ERR = "BUS_MONITORING_SAVE_ERR"
}

export interface IBusMonitoringLoadStart {
	type: eBusMonitoringActionTypeIds.LOAD_START,
	payload: number
}
export interface IBusMonitoringLoadSuccess {
	type: eBusMonitoringActionTypeIds.LOAD_SUCCESS,
	payload: bus_monitoring[]
}
export interface IBusMonitoringLoadErr {
	type: eBusMonitoringActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusMonitoringShowDetail {
	type: eBusMonitoringActionTypeIds.SHOW_DETAIL,
	payload?: bus_monitoring
}
export interface IBusMonitoringCloseDetail {
	type: eBusMonitoringActionTypeIds.CLOSE_DETAIL
}
export interface IBusMonitoringChangeSelectedIds {
	type: eBusMonitoringActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusMonitoringShowConfirm {
	type: eBusMonitoringActionTypeIds.SHOW_CONFIRM
}
export interface IBusMonitoringCloseConfirm {
	type: eBusMonitoringActionTypeIds.CLOSE_CONFIRM
}
export interface IBusMonitoringDeleteStart {
	type: eBusMonitoringActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusMonitoringDeleteSuccess {
	type: eBusMonitoringActionTypeIds.DELETE_SUCCESS
}
export interface IBusMonitoringDeleteErr {
	type: eBusMonitoringActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusMonitoringSaveStart {
	type: eBusMonitoringActionTypeIds.SAVE_START,
	payload: bus_monitoring
}
export interface IBusMonitoringSaveSuccess {
	type: eBusMonitoringActionTypeIds.SAVE_SUCCESS
}
export interface IBusMonitoringSaveErr {
	type: eBusMonitoringActionTypeIds.SAVE_ERR,
	payload: string
}

export type IBusMonitoringActionTypes = IBusMonitoringLoadStart | IBusMonitoringLoadSuccess | IBusMonitoringLoadErr |
	IBusMonitoringShowDetail | IBusMonitoringCloseDetail |
	IBusMonitoringChangeSelectedIds |
	IBusMonitoringShowConfirm | IBusMonitoringCloseConfirm |
	IBusMonitoringDeleteStart | IBusMonitoringDeleteSuccess | IBusMonitoringDeleteErr |
	IBusMonitoringSaveStart | IBusMonitoringSaveSuccess | IBusMonitoringSaveErr
